export const C_AVATARS_PER_PAGE = {
  mobile: 16, // change to 16
  desktop: 24 // change to 24
} as const;

export const C_DEFAULT_AVATAR = '/assets/images/profile-default.png';
